/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderPaymentMethod
 */
export interface OrderPaymentMethod {
    /**
     * 
     * @type {boolean}
     * @memberof OrderPaymentMethod
     */
    isDefault?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentMethod
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentMethod
     */
    name?: string;
}

/**
 * Check if a given object implements the OrderPaymentMethod interface.
 */
export function instanceOfOrderPaymentMethod(value: object): value is OrderPaymentMethod {
    return true;
}

export function OrderPaymentMethodFromJSON(json: any): OrderPaymentMethod {
    return OrderPaymentMethodFromJSONTyped(json, false);
}

export function OrderPaymentMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderPaymentMethod {
    if (json == null) {
        return json;
    }
    return {
        
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function OrderPaymentMethodToJSON(json: any): OrderPaymentMethod {
    return OrderPaymentMethodToJSONTyped(json, false);
}

export function OrderPaymentMethodToJSONTyped(value?: OrderPaymentMethod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isDefault': value['isDefault'],
        'remoteId': value['remoteId'],
        'name': value['name'],
    };
}

